export enum MealType {
  BREAKFAST = "BREAKFAST",
  LUNCH = "LUNCH",
  SNACKS = "SNACKS",
  DINNER = "DINNER",
}
export const MealTypeList = Object.values(MealType);
